import { chat } from '../../stores/chat';
import { ChatSocket } from '../../hooks/use-socket';
import { ChatCommon } from '../../types/bingo-events/in/chat/common';

export const onUnmute = (socket: ChatSocket) => {
    const callback = (response: ChatCommon) => {
        if (response.message) {
            chat.messages.merge([
                {
                    message: response.message,
                    isSystemMsg: true,
                    isWelcomeMsg: false,
                },
            ]);
        }
    };

    socket.on('unmute:parlay', callback);

    return () => {
        socket.off('unmute:parlay', callback);
    };
};
